import React from 'react'
import {
    ContainerFluid,ContainerFluidX,ContainerFluidY,Container,ContainerX,HeadingText,DescText,
    Bagde
} from './SectionCComponent.style';
function SectionCComponent() {
  return (
    <div>
        <ContainerFluidX></ContainerFluidX>
        <ContainerFluid>
            
            <Container>
                <div className='row'>
                    <div className='col s12 m12 l6 center' >
                        <div style={{height:"75px"}}></div>
                        <img width="66%"  style={{
                            marginBottom:"-7px"
                        }}  src="https://res.cloudinary.com/yalla-ng/image/upload/v1663522186/re-brand/CI_1_vx1swl.svg" alt=""/>
                    </div>
                    <div className='col s12 m12 l6 '>
                            <Container>
                            <div className='row mt-100'>
                                {/* <div className='col s12 m12 l1'></div> */}
                                <div className='col s12 m12 l11 mt-100'>
                                    <ContainerX className=''>
                                        <Bagde>
                                            Investment
                                        </Bagde>
                                        <HeadingText>
                                        Trade in food commodities 
                                        such as rice, beans, millets, 
                                        etc.  
                                        </HeadingText>
                                    </ContainerX>
                                </div>
                                {/* <div className='col s12 m12 l1'></div> */}
                                <div className='col s12 m12 l9'>
                                    <ContainerX>
                                        <DescText>
                                            You invest, we take care of the trading.
                                        </DescText>
                                    </ContainerX>
                                </div>
                            </div>
                            </Container>
                    </div>
                        
                </div>
                <div className='row'>
                    
                    <div className='col s12 m12 l6 '>
                            <Container>
                            <div className='row mt-100'>
                                {/* <div className='col s12 m12 l1'></div> */}
                                <div className='col s12 m12 l11 mt-100'>
                                    <ContainerX className=''>
                                        <Bagde>
                                            Purse
                                        </Bagde>
                                        <HeadingText>
                                        Move your money around
                                        </HeadingText>
                                    </ContainerX>
                                </div>
                                {/* <div className='col s12 m12 l1'></div> */}
                                <div className='col s12 m12 l9'>
                                    <ContainerX>
                                        <DescText>
                                            Easily transfer your money to your savings 
                                            or investment plan from purse.  
                                        </DescText>
                                    </ContainerX>
                                </div>
                            </div>
                            </Container>
                    </div>
                    <div className='col s12 m12 l6 center' >
                        <div style={{height:"75px"}}></div>
                        <img width="66%"  style={{
                            marginBottom:"-7px"
                        }}  src="https://res.cloudinary.com/yalla-ng/image/upload/v1657622292/re-brand/Group_797_bfzhn0.svg" alt=""/>
                    </div> 
                </div>
                <div className='row'>
                    <div className='col s12 m12 l6 center' >
                        <div style={{height:"75px"}}></div>
                        <img width="66%"  style={{
                            marginBottom:"-7px"
                        }}  src="https://res.cloudinary.com/yalla-ng/image/upload/v1668333270/re-brand/idevices_mockup_23_1_m9jerk.svg" alt=""/>
                    </div> 
                    <div className='col s12 m12 l6 '>
                        <Container>
                            <div className='row mt-100'>
                                {/* <div className='col s12 m12 l1'></div> */}
                                <div className='col s12 m12 l11 mt-100'>
                                    <ContainerX className=''>
                                        <Bagde>
                                            Double-edged Investment
                                        </Bagde>
                                        <HeadingText>
                                        Take steps towards Hajj 
                                        and Umrah
                                        </HeadingText>
                                    </ContainerX>
                                </div>
                                {/* <div className='col s12 m12 l1'></div> */}
                                <div className='col s12 m12 l9'>
                                    <ContainerX>
                                        <DescText>
                                            Whether big or small, save towards your religious 
                                            obligations and earn returns at the same time. 
                                        </DescText>
                                    </ContainerX>
                                </div>
                            </div>
                        </Container>
                    </div>
                   
                </div>
            </Container>
        </ContainerFluid>
        
        <ContainerFluidY></ContainerFluidY>
    </div>
  )
}

export default SectionCComponent